import classNames from "classnames";
import React, { FC, useEffect, useState } from "react";
import "./Accordion.scss";

const contentMarginHeight = 8;

export const Accordion: FC<{ maxHeight: number }> = (props) => (
    <div className="accordion" style={{ maxHeight: props.maxHeight + "px" }}>
        {props.children}
    </div>
);

export const AccordionItem: FC<{
    title: string;
    defaultExpanded?: number;
    changeHeight?: number;
    nonExpandable?: boolean;
    class?: string;
    onExpand?: (expanded: boolean) => void;
}> = (props) => {
    const headerHeight = props.nonExpandable ? 0 : 40; // same as in css

    const [expanded, setExpanded] = useState<number>(props.defaultExpanded || 0);
    const [contentHeight, setContentHeight] = useState<number>(0);
    const [height, setHeight] = useState<number>(headerHeight);

    const onClick = () => {
        const isExpanded = expanded ? 0 : Date.now();
        setExpanded(isExpanded);
        props.onExpand && props.onExpand(!!isExpanded);
    };

    useEffect(() => {
        const content = document.getElementById(props.title);
        content && setContentHeight(content.scrollHeight);
    }, []);

    useEffect(() => {
        setTimeout(() => {
            const content = document.getElementById(props.title);
            content && setContentHeight(content.scrollHeight);
        }, 0);
    }, [props.changeHeight]);

    useEffect(() => {
        expanded ? setHeight(headerHeight + contentHeight + contentMarginHeight) : setHeight(headerHeight);
    }, [expanded, contentHeight]);

    const style = { height: height + "px" };
    return (
        <div className={"accordion-item " + props.class} style={style} title={props.title}>
            {!props.nonExpandable && (
                <div className="accordion-item-header" onClick={onClick}>
                    <div className="item-title unselectable">{props.title}</div>
                    <div className={classNames("item-icon", { minus: expanded })}>
                        <span className="icon-geolite-chevron-down"></span>
                    </div>
                </div>
            )}
            <div id={props.title} className={"accordion-item-content"}>
                {props.children}
            </div>
        </div>
    );
};
